"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_autosuggest_1 = require("../input/awsui-autosuggest");
var awsui_button_dropdown_1 = require("../button/awsui-button-dropdown");
var awsui_button_1 = require("../button/awsui-button");
var FilteringTokenWrapper = /** @class */ (function (_super) {
    __extends(FilteringTokenWrapper, _super);
    function FilteringTokenWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FilteringTokenWrapper.prototype.findTokenOperation = function () {
        var dropdownElement = this.find('awsui-button-dropdown');
        if (dropdownElement) {
            return new awsui_button_dropdown_1.default(dropdownElement.getElement());
        }
        return null;
    };
    FilteringTokenWrapper.prototype.findLabel = function () {
        return this.find('.awsui-select-option-label');
    };
    FilteringTokenWrapper.prototype.findRemoveButton = function () {
        return this.find('.awsui-token-dismiss');
    };
    return FilteringTokenWrapper;
}(dom_1.ElementWrapper));
exports.FilteringTokenWrapper = FilteringTokenWrapper;
var BaseCollectionPropertyFilteringWrapper = /** @class */ (function (_super) {
    __extends(BaseCollectionPropertyFilteringWrapper, _super);
    function BaseCollectionPropertyFilteringWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseCollectionPropertyFilteringWrapper.prototype.findTokens = function () {
        return this.findAll(".awsui-" + this.name + "-property-filtering-token").map(function (r) { return new FilteringTokenWrapper(r.getElement()); });
    };
    BaseCollectionPropertyFilteringWrapper.prototype.findClearTokensButton = function () {
        return new awsui_button_1.default(this.find(".awsui-" + this.name + "-property-filtering-clear-filters").getElement());
    };
    return BaseCollectionPropertyFilteringWrapper;
}(awsui_autosuggest_1.default));
exports.BaseCollectionPropertyFilteringWrapper = BaseCollectionPropertyFilteringWrapper;
var TablePropertyFilteringWrapper = /** @class */ (function (_super) {
    __extends(TablePropertyFilteringWrapper, _super);
    function TablePropertyFilteringWrapper(element) {
        var _this = _super.call(this, element) || this;
        _this.name = 'table';
        return _this;
    }
    /**
     * Returns a property filtering option for a given index.
     *
     * @param optionIndex 1-based index of the option to return.
     */
    TablePropertyFilteringWrapper.prototype.findOption = function (optionIndex) {
        return this.find(".awsui-select-dropdown-option:nth-child(" + optionIndex + ") .awsui-select-option");
    };
    TablePropertyFilteringWrapper.prototype.findResultsCount = function () {
        return this.find('.awsui-filtering-results');
    };
    return TablePropertyFilteringWrapper;
}(BaseCollectionPropertyFilteringWrapper));
exports.default = TablePropertyFilteringWrapper;
//# sourceMappingURL=awsui-table-property-filtering.js.map